<template>
  <md-modal-dialog class="md-dialog" @md-opened="event = 'md-opened'">
    <ModalWrapper>
      <RegionsFilter @close="onModalClose" />
    </ModalWrapper>
  </md-modal-dialog>
</template>

<script>
import Vue from 'vue';
import RegionsFilter from './regions-filter.vue';
import {ModalWrapper} from '@mobi-components/amex-bluesky-components';
import VueCompositionAPI, {defineComponent} from '@vue/composition-api';
Vue.use(VueCompositionAPI);

export default defineComponent({
  name: 'region-picker-dialog',
  components: {
    ModalWrapper,
    RegionsFilter,
  },
  methods: {
    onModalClose() {
      this.$modal.submit();
    },
  },
});
</script>

<style scoped>
.md-dialog {
  /* --md-theme-default-primary: var(--primary); */
  /* --md-theme-default-primary-on-background: var(--primary); */
  /* --md-theme-default-accent-on-background: transparent; */
  /* --md-theme-default-text-primary-on-accent: var(
    --md-theme-default-text-primary-on-background-variant,
    rgba(0, 0, 0, 0.87)
  ); */
}
</style>

<style>
.md-dialog-container.md-theme-default {
  width: 100%;
  border-radius: 20px;
}
</style>
